import { h, Component } from 'preact';
import Store from 'store/store';

import { parseDate, joinClasses } from 'utils/utils';
import formatDateTime from 'utils/formatDateTime';
import { canUser } from 'utils/roles';

import Button from 'components/button/button';
import { SortableItem, Handle } from 'components/sortable/sortable';
import Pin from 'components/icons/pin';

import s from 'components/editor/settings/carouselSettings/carouselItem.sss';

export default class CarouselItem extends Component {
	get status() {
		return this.props.movie && Store.get().movieStatuses?.[this.props.movie.id] || {};
	}

	get tags() {
		const theaterStatusNames = { inTheaters: 'In theaters', preSale: 'Pre-sale', comingSoon: 'Coming soon' };
		const {	movie } = this.props;

		const tags = [
			theaterStatusNames[this.status.theaters],
			this.status.homeEnt === 'homeEnt' && 'At home',
		].filter(Boolean);

		const releaseDate = movie?.dates?.release;
		if (releaseDate) {
			let format = 'MMM dd, yyyy';
			if (/^\d{4}$/.test(releaseDate)) {
				format = 'yyyy';
			} else if (/^\d{4}-\d{2}$/.test(releaseDate)) {
				format = 'MMM yyyy';
			}
			tags.push(formatDateTime(parseDate(releaseDate), format));
		}

		return tags;
	}

	render(props) {
		const {	customData, movie, onAddClick, onEditClick, onRemoveClick, sortType, togglePinned } = props;
		if (!movie) return;

		const readonly = !canUser('write');
		const edits = [
			['primaryButtonText', 'primaryButtonLink'], // Universal
			['secondaryButtonText', 'secondaryButtonLink'], // Universal
			['ctaText', 'link'], // Focus
		].filter(group => group.some(e => customData?.[e])).length;

		let Tag = 'div';
		let icon;
		if (sortType === 'custom') {
			Tag = SortableItem;
			icon = <Handle class={s.handle} />;
		} else if (sortType === 'pin') {
			icon = <button class={joinClasses(s.pin, customData?.pinned && s.pinned)} onClick={togglePinned} disabled={readonly}><Pin /></button>;
		}

		return (
			<Tag class={s.wrapper} data-movie={movie.id}>
				{icon}
				<div class={s.container}>
					<div class={s.header}>
						<a class={s.title} href={`#movies/${movie.id}/edit`} target="_blank">{movie.title}</a>
						<div class={s.actions}>
							{onEditClick && <Button primary iconSize="small" icon="edit" counter={edits || null} class={s.actionButton} onClick={onEditClick} data-hover-label="Edit CTAs" />}
							{onAddClick && <Button primary iconSize="small" icon="plus" class={s.actionButton} onClick={onAddClick} data-hover-label="Add to carousel" disabled={readonly} />}
							{onRemoveClick && <Button primary iconSize="small" icon="minus" class={s.actionButton} onClick={onRemoveClick} disabled={readonly} />}
						</div>
					</div>
					<div class={s.tags}>
						{this.tags.map(tag => <div>{tag}</div>)}
					</div>
				</div>
			</Tag>
		);
	}
}